import React from "react";
import { Wrapper } from "./EventsCalendar.styled";
import { Row, Col, Radio, Spin, Card, Empty } from "components/common";
import { useState } from "react";
import Calendar from "react-calendar";
import moment from "moment";
import { callPostApiWithAuth } from "utils/api";
import { useEffect } from "react";
const EventsCalendar = () => {
  const defaultDate = new Date();
  const [dateInput, setDateInput] = useState(defaultDate);
  const [isloading, setIsLoading] = useState(false);
  const [showTimeSpan, setshowTimeSpan] = useState(false);
  const [leadEvents, setLeadEvents] = useState([]);
  const [methodInput, setMethodInput] = useState("appointmentTime");
  const onChange = (e) => {
    setMethodInput(e.target.value)
  };

  const calendarEvents = (e) => {
    setDateInput(e);
    setshowTimeSpan(false);
  };

  const calendarEventPostApi = () => {
    let data = {
      methodInput: methodInput,
      dateInput: moment(dateInput).format("MM/DD/YYYY"),
    };
    callPostApiWithAuth(
      "/leads/get/Leads/Event/by/date",
      data,
      onSuccessCalendarEvent,
      onFailedcalendarEvent
    );
  };

  const onSuccessCalendarEvent = (data) => {
    setLeadEvents(data);
    setIsLoading(false);
    setshowTimeSpan(true);
  };
  const onFailedcalendarEvent = (err) => {
    setIsLoading(false);
  };

  useEffect(() => {
    calendarEventPostApi();
  }, [dateInput, methodInput]);

  const leadLenght = leadEvents.length;
  return (
    <Wrapper>
      <Row
        gutter={[0, 20]}
        className="main-container"
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
        }}
      >
        <Col lg={14} xs={24} className="main-calendar-data">
          <Row>
            <Col span={24}>
              {" "}
              <Radio.Group
                onChange={onChange}
                value={methodInput}
                optionType="button"
                buttonStyle="solid"
              >
                <Radio value={"appointmentTime"}>Appointments</Radio>
                <Radio value={"installs"}>Installs</Radio>
                <Radio value={"scheduled_install"}>Surveys</Radio>
              </Radio.Group>
            </Col>
          </Row>

          <Col span={24} className="Calendar-column">
            <Calendar
              value={dateInput}
              onChange={(e) => {
                calendarEvents(e);
                setIsLoading(true);
              }}
            />
          </Col>
        </Col>
        <Row gutter={[0, 10]}>
          {isloading && (
            <Col span={24} className="time-data">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <Spin spinning={true} />
              </div>
            </Col>
          )}
          <Col
            span={24}
            className="time-data"
            style={{ display: showTimeSpan ? "block" : "none" }}
          >
            <Empty
              style={{
                color: "#fff",
                display: leadLenght == 0 ? "block" : "none",
              }}
            />
            {leadLenght && (
              <div className="header-tag">
                <h4>{methodInput === 'appointmentTime' ? "Appointment Time " : methodInput}</h4>
              </div>
            )}

            {leadEvents?.map((item) => {
              return (
                <>
                  <Col
                    span={24}
                    style={{
                      marginBottom: "10px",
                      background: "white",
                      borderRadius:"4px",
                    }}
                  >
                    <div
                      className="information-card"
                      style={{ borderRadius: "10px" }}
                    >
                      <h6 className="heading-six">
                        <label>
                          Name:{" "}
                          {item.firstName
                            ? item?.firstName
                            : item?.first_name
                            ? item?.first_name
                            : item?.customer_name.split(" ")[0]}{" "}
                          {item.lastName
                            ? item.lastName
                            : item?.last_name
                            ? item?.last_name
                            : item?.customer_name.split(" ")[1]}
                        </label>
                      </h6>
                      {item?.apptTime && (
                        <h6 className="heading-six">
                          <label>Appointment Time: {item?.apptTime}</label>
                        </h6>
                      )}

                      <h6 className="heading-six">
                        <label>
                          Address:{" "}
                          {item?.street ? item?.street : item?.customer_street}{" "}
                          {item?.city ? item?.city : item?.customer_city}{" "}
                          {item?.state ? item?.state : item?.customer_state}
                        </label>
                      </h6>
                      {item?.kw && (
                        <h6 className="heading-six">
                          <label>System Size: {item?.kw}</label>
                        </h6>
                      )}
                    </div>
                  </Col>
                </>
              );
            })}
          </Col>
        </Row>
      </Row>
    </Wrapper>
  );
};

export default EventsCalendar;
